import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { LoginModel } from 'src/app/models/seguridad/LoginModel';
import { SessionModel } from 'src/app/models/seguridad/SesionModel';
import { OktaAuthService } from 'src/app/services/OktaAuth/okta-auth.service';
import { AutenticacionService } from 'src/app/services/seguridad/autenticacion/autenticacion.service';
import { SeguridadUsuarioService } from 'src/app/services/seguridad/seguridad-usuario.service';
import { UsuarioService } from 'src/app/services/seguridad/usuario/usuario.service';
import { StorageService } from 'src/app/services/storage/storage.service';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.css']
})
export class LoginComponent implements OnInit {
  hide = true;
  model: LoginModel;
  returnUrl: string = '';
  displayError = false;

  constructor(
    private route: ActivatedRoute,
    private service: AutenticacionService,
    private seguridadUsuarioService: SeguridadUsuarioService,
    private storageService: StorageService,
    private router: Router,
    private okta: OktaAuthService, 
  ) { 
    this.model = new LoginModel();    
  }

  ngOnInit(): void {

    this.returnUrl = this.route.snapshot.queryParams['returnUrl'] || '/';
  }

  login(idTipo: number): void{
    this.service.login(this.model, idTipo).subscribe(p => {      
      // localStorage.setItem('id_token', p.accessToken);
      this.storageService.removeCurrentSession();
      this.storageService.setCurrentToken(p);

      let session: SessionModel = new SessionModel();
      // console.log(p);
      if(p.succeeded){
        this.displayError = false;
        // console.log("logged");
        this.seguridadUsuarioService.getCurrent().subscribe(q => {        
          // console.log("getting access token");

          session.token = p.accessToken;
          session.user = q;
          session.user.isLogged = true;
          session.user.nombres = q.nombres;
          session.user.apellidos = q.apellidos;

          // console.log(session);

          this.storageService.setCurrentSession(session);
          // this.router.navigate(['/']);
          this.router.navigateByUrl(this.returnUrl);
        });
      }
      else{
        this.displayError = true;
      }
    });
  }

  loginOkta(){
    // // Redirect to login flow.
    console.log(this.returnUrl);
    this.okta.login(this.returnUrl);
    // this.oktaAuth.signInWithRedirect({
    //   originalUri: '/profile'
    // }); 
  }
}
